/* Newsletter popup v2 — "minimal first" bubble choreography.
   Design source: claude.ai/design project b3cdbd17 → "Newsletter Popup v2.html".

   The visitor is never met by the email form. A minimal bubble arrives bottom
   left, introduces itself once, then shrinks to an icon and waits. The form
   only ever opens on a click.

   Timeline (from the moment the bubble lands):
     +0.0s  arrival — slide up + two gold rings pulse outward
     +0.6s  self-introduction — the pill expands on its own for 5s (4s on
            mobile) with a gold progress line underneath. Once per SESSION.
     +5.6s  collapses back to the icon + "1" badge
     loop   ambient: one soft bob + halo + icon nudge every 9s
     +35s   second reminder — expands once more for 3.5s with different copy,
            then never again this session

   Memory (localStorage `tl_nl_v2`):
     claimed:true              → nothing is ever shown again
     dismissed:true + until    → nothing is shown until `until` (bubble's ×)
   Session (sessionStorage `tl_nl_v2_session`):
     teased  → the self-introduction already played this session
     nudged  → the second reminder already played this session
     opened  → the form was opened at least once; cancels tease + nudge

   popup.js calls into window.TLNewsletterV2 for the suppression checks so the
   Alpine component and this file share one source of truth. */
(function () {
  var LK = 'tl_nl_v2';
  var SK = 'tl_nl_v2_session';

  var TEASE_DELAY_MS = 600; // pause between landing and the self-introduction
  var TEASE_MS = 5000; // desktop self-introduction
  var TEASE_MS_MOBILE = 4000; // mobile — shorter, the design asks for 4s
  var NUDGE_AT_MS = 35000; // second reminder, measured from arrival
  var NUDGE_MS = 3500;
  var ARRIVE_MS = 700; // ring pulse / settle before anything else happens
  var DISMISS_DAYS = 15; // fallback when the theme setting is unavailable
  var MOBILE_MAX = 767;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function read(store, key) {
    try {
      return JSON.parse(store.getItem(key)) || {};
    } catch (x) {
      return {};
    }
  }
  function write(store, key, obj) {
    try {
      store.setItem(key, JSON.stringify(obj));
    } catch (x) {}
  }
  function readL() {
    return read(localStorage, LK);
  }
  function writeL(o) {
    write(localStorage, LK, o);
  }
  function readS() {
    return read(sessionStorage, SK);
  }
  function patchS(k) {
    var s = readS();
    s[k] = true;
    write(sessionStorage, SK, s);
  }

  /* Nothing at all is shown while this is true — no bubble, no form. */
  function suppressed() {
    /* The bottom-left corner belongs to the cookie banner until the visitor
       answers it; two invitations in the same corner read as clutter. The
       banner hands the corner back 4s after the decision (see
       assets/cookie-banner.js). Absent banner → no gate. */
    if (window.TLCookieConsent && !window.TLCookieConsent.newsletterAllowed()) return true;
    var L = readL();
    if (L.claimed) return true;
    if (L.dismissed) {
      if (!L.until || L.until > Date.now()) return true;
      // the quiet period is over — forget it and let the bubble try once more
      L.dismissed = false;
      delete L.until;
      writeL(L);
    }
    return false;
  }

  var api = {
    suppressed: suppressed,
    /* the form was opened (or closed again) — the bubble stays, but it stops
       asking for attention for the rest of the session */
    markOpened: function () {
      patchS('opened');
      cancel();
    },
    /* the bubble's × — a clear no. Nothing is shown for DISMISS_DAYS. */
    dismiss: function (days) {
      var d = parseInt(days, 10);
      if (!d || d < 1) d = DISMISS_DAYS;
      var L = readL();
      L.dismissed = true;
      L.until = Date.now() + d * 86400000;
      writeL(L);
      cancel();
    },
    /* subscribed — the offer is closed for good */
    markClaimed: function () {
      var L = readL();
      L.claimed = true;
      L.dismissed = false;
      delete L.until;
      writeL(L);
      cancel();
    }
  };
  window.TLNewsletterV2 = api;

  /* ---------------------------------------------------------------- bubble */

  var timers = [];
  var wrap = null; // the teleported minimal wrapper
  var pill = null;
  var arrived = false;

  function later(fn, ms) {
    timers.push(setTimeout(fn, ms));
  }
  function cancel() {
    timers.forEach(clearTimeout);
    timers = [];
    if (pill) {
      pill.classList.remove('tl-pp-min--open');
      pill.classList.add('tl-pp-min--idle');
      resetProgress();
      setCopy('default');
    }
  }

  function parts() {
    if (!pill) return {};
    return {
      title: pill.querySelector('[class*="heading-minimal-"]'),
      sub: pill.querySelector('.tl-pp-min-sub'),
      prog: pill.querySelector('.tl-pp-min-prog')
    };
  }

  function setCopy(mode) {
    var p = parts();
    if (!wrap) return;
    var d = wrap.dataset;
    if (mode === 'nudge') {
      if (p.title && d.tlNudgeTitle) p.title.textContent = d.tlNudgeTitle;
      if (p.sub && d.tlNudgeSub) p.sub.textContent = d.tlNudgeSub;
    } else {
      if (p.title && d.tlTitle != null) p.title.textContent = d.tlTitle;
      if (p.sub && d.tlSub != null) p.sub.textContent = d.tlSub;
    }
    // the subtitle line is optional — collapse it when there is nothing to say
    if (p.sub) p.sub.hidden = !p.sub.textContent.trim();
  }

  function resetProgress() {
    var p = parts();
    if (!p.prog) return;
    p.prog.style.transition = 'none';
    p.prog.style.transform = 'scaleX(0)';
  }

  /* Expand the pill on its own for `ms`, draining the gold progress line, then
     collapse back to the icon. */
  function tease(ms, mode) {
    if (!pill || suppressed()) return;
    setCopy(mode);
    pill.classList.remove('tl-pp-min--idle');
    pill.classList.add('tl-pp-min--open');

    var p = parts();
    if (p.prog) {
      p.prog.style.transition = 'none';
      p.prog.style.transform = 'scaleX(1)';
      void p.prog.offsetWidth; // force the reset to land before we animate
      p.prog.style.transition = 'transform ' + ms + 'ms linear';
      p.prog.style.transform = 'scaleX(0)';
    }

    later(function () {
      pill.classList.remove('tl-pp-min--open');
      pill.classList.add('tl-pp-min--idle');
      resetProgress();
      setCopy('default');
    }, ms);
  }

  /* The gold rings, replayed from scratch. */
  function pulse() {
    if (!wrap) return;
    wrap.classList.remove('tl-pp-min--arrive');
    void wrap.offsetWidth; // restart the animation rather than letting it sit finished
    wrap.classList.add('tl-pp-min--arrive');
  }

  /* Runs once, the first time the bubble becomes visible on this page. */
  function arrive() {
    if (arrived || !pill) return;
    arrived = true;
    pulse();

    later(function () {
      pill.classList.add('tl-pp-min--idle');

      var S = readS();
      if (!S.teased && !S.opened) {
        patchS('teased');
        later(function () {
          tease(isMobile() ? TEASE_MS_MOBILE : TEASE_MS, 'default');
        }, TEASE_DELAY_MS);
      }

      // second reminder — only if the visitor never opened the form
      later(function () {
        var s = readS();
        if (s.opened || s.nudged || suppressed()) return;
        patchS('nudged');
        tease(NUDGE_MS, 'nudge');
      }, NUDGE_AT_MS);
    }, ARRIVE_MS);
  }

  /* A tap/click anywhere on the bubble opens the form — stop asking. */
  document.addEventListener(
    'click',
    function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (t.closest('.tl-pp-min-x')) return; // handled by closeMinimal()
      if (t.closest('.tl-pp-min')) api.markOpened();
    },
    true
  );

  /* ------------------------------------------------- teleport + ATC offset */

  /* Alpine teleports the bubble into #popup-minimal-*, so we watch that
     container rather than binding at load time. */
  var wasVisible = false;
  function scan() {
    var next = document.querySelector('.popup-minimal .tl-pp-min');
    if (!next) return;
    if (next !== pill) {
      pill = next;
      wrap = pill.closest('.tl-pp-minwrap') || pill.parentElement;
      arrived = false;
      wasVisible = false;
      // remember the resting copy so the nudge can be swapped back out
      var p = parts();
      if (wrap && wrap.dataset.tlTitle == null) {
        wrap.dataset.tlTitle = p.title ? p.title.textContent.trim() : '';
        wrap.dataset.tlSub = p.sub ? p.sub.textContent.trim() : '';
      }
      setCopy('default');
      resetProgress();
    }
    // offsetParent is null while Alpine keeps it display:none
    var visible = !!pill.offsetParent;
    if (visible && !wasVisible) {
      if (!arrived) {
        arrive();
      } else {
        // coming back after the form was closed — the same landing beat, but
        // no self-introduction and no reminder; the visitor already answered
        pulse();
        pill.classList.add('tl-pp-min--idle');
      }
    }
    wasVisible = visible;
  }

  /* Mobile: sit above the sticky Add to cart bar when one is on screen.
     Written only on change — the container is under a MutationObserver and a
     no-op style write would feed itself. */
  var lastATC = null;
  function trackStickyATC() {
    var host = document.querySelector('.popup-minimal');
    if (!host) return;
    var bar = document.querySelector('.sticky_add_to_cart');
    // offsetParent is null for a position:fixed element, which the sticky bar
    // is — measure the box instead, or this always reads 0 and the bubble sits
    // on top of the Add to cart bar it is supposed to clear
    var h = (bar && bar.getClientRects().length ? bar.getBoundingClientRect().height : 0) + 'px';
    if (h === lastATC) return;
    lastATC = h;
    host.style.setProperty('--tl-pp-min-atc', h);
  }

  function tick() {
    scan();
    trackStickyATC();
  }

  /* scan() and trackStickyATC() both read layout (offsetParent, getBoundingClientRect).
     Their triggers fire far more often than once a frame — a body-wide MutationObserver
     while Alpine and the sliders hydrate, plus every scroll event — and each call forced a
     synchronous layout. Running them at most once per frame keeps the behaviour and drops
     the repeated reflows. Both writers are already no-op guarded, so the observer that
     these runs wake up settles on the next frame instead of looping. */
  function perFrame(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        fn();
      });
    };
  }
  var scheduleTick = perFrame(tick);
  var scheduleStickyATC = perFrame(trackStickyATC);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  document.addEventListener('alpine:initialized', tick);

  var minHost = document.querySelector('.popup-minimal');
  if (minHost) {
    new MutationObserver(scheduleTick).observe(minHost, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  } else {
    // the container is rendered by snippets/popups.liquid at the end of body
    new MutationObserver(scheduleTick).observe(document.body, { childList: true, subtree: true });
  }
  // the sticky bar toggles on scroll, well outside the popup subtree
  window.addEventListener('scroll', scheduleStickyATC, { passive: true });
  window.addEventListener('resize', scheduleStickyATC);
})();
